import { useCallback, useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { BaseCrud, IDataProviderFilter, IFilter, Logic } from 'core-components/types'

import { useBaseSource } from './useBaseSource'

export const useFilterSource = <T = IForm, R = string | number>({
  source,
  filter,
  caption,
  emptyValueLabel,
  maxListPageSize,
  onDataLoad,
}: {
  source: BaseCrud<T, R>
  filter?: IDataProviderFilter
  caption: string | ((item: T) => string)
  emptyValueLabel?: { value: string; dropDownKey?: string }
  maxListPageSize?: number
  onDataLoad?: (items: T[]) => void
}) => {
  const [sourceFilter, setSourceFilter] = useState<IDataProviderFilter | undefined>(filter)
  const { staticSource, initialData, isDataLoading } = useBaseSource({
    source,
    caption,
    emptyValueLabel,
    maxListPageSize,
    fetchFilter: sourceFilter,
    onDataLoad,
  })

  const updateSourceFilter = useCallback(
    (newFilters: Array<IFilter | IDataProviderFilter>) => {
      if (filter) {
        const mergedFilter: IDataProviderFilter = {
          ...filter,
          filters: [...filter.filters, ...newFilters],
        }
        setSourceFilter((prev) => {
          return JSON.stringify(prev) === JSON.stringify(mergedFilter) ? prev : mergedFilter
        })
      } else {
        const newFilter = {
          filters: newFilters,
          logic: Logic.AND,
        }
        setSourceFilter((prev) => {
          return JSON.stringify(prev) === JSON.stringify(newFilter) ? prev : newFilter
        })
      }
    },
    [filter]
  )

  return { staticSource, data: initialData, isDataLoading, updateSourceFilter }
}
